import React from 'react'
import { useDataContext } from '@/app/_context';
import { AvatarFallback } from '@/components/ui/avatar';

export default function GenericAvatarFallback() {

	const { currentProjectInfo } = useDataContext()

  return (
	  <AvatarFallback className="text-xs font-medium">
		  {currentProjectInfo.authorName
			  ? currentProjectInfo.authorName
				  .split(' ') // Split by spaces
				  .map((name, index, arr) => {
					  // If it's a single word, just take the first letter
					  if (arr.length === 1) return name[0].toUpperCase();
					  // Otherwise, take the first letter of each word
					  return name[0].toUpperCase();
				  })
				  .join('') // Join initials together
			  : ''}
	  </AvatarFallback>
  )
}
